export default "__VITE_ASSET__Ch7oV$7a__"